import { useNavigate } from 'react-router';
import { BASE_PATH } from '@/helpers/constants';

const UseGoTo = () => {
  const navigate = useNavigate();

  const goTo = (location: string | { pathname?: string; search?: string; campaign?: string }, timeout: number = 0) => {
    setTimeout(() => {
      // Automatically prepend BASE_PATH if not already present
      if (typeof location === 'string') {
        const path = location.startsWith(BASE_PATH) ? location : `${BASE_PATH}${location}`;
        navigate(path);
      } else if (typeof location === 'object' && location.pathname) {
        const pathname = location.pathname.startsWith(BASE_PATH) ? location.pathname : `${BASE_PATH}${location.pathname}`;
        navigate({ ...location, pathname });
      } else {
        navigate(location);
      }
    }, timeout);
  };

  return {
    goTo,
  };
};

export default UseGoTo;
